<div class="glassy-table card-nav-tabs mt-0 rounded-lg border-0 shadow-lg">
  <div class="card-body text-xxs">
    <!-- Show upload form for non-Lead roles -->
    <div v-if="user_role !== 'Lead'">
      <!-- Template Name Input -->
      <div class="mb-3">
        <label for="meeting_date" class="form-label fw-bold">Minutes Date</label>
        <input
          type="datetime-local"
          class="form-control text-xxs"
          id="meeting_date"
          placeholder="Date of the actual meeting"
          v-model="meeting_date"
        />
      </div>

      <div class="mb-3">
        <label for="comments" class="form-label fw-bold">Comments</label>
        <input
          type="text"
          class="form-control text-xxs"
          id="comments"
          placeholder="Add comments about the meeting minutes"
          v-model="comments"
        />
      </div>

      <!-- File Upload Input -->
      <div class="mb-3">
        <label for="template_file" class="form-label fw-bold">Upload Minutes File</label>
        <input
          ref="fileInput"
          class="form-control text-xxs"
          type="file"
          id="minutes_file"
          multiple
          @change="handle_file_selection"
        />
      </div>

      <!-- File Preview -->
      <div v-if="preview_url" class="mt-3">
        <iframe
          v-if="is_previewable"
          :src="preview_url"
          width="100%"
          height="500px"
        ></iframe>
        <div v-else>
          <p>Preview unavailable for this file type.</p>
        </div>
      </div>

      <!-- Save Button -->
      <div class="modal-footer border-0 p-2 d-flex justify-content-end">
        <button
          type="button"
          class="btn btn-primary-dark btn-sm shadow-sm text-xxs"
          @click="upload_template"
          :disabled="upload_loading"  
        >
          {{ upload_loading ? "Uploading…" : "Save" }}
        </button>
      </div>
    </div>

    <!-- Past Meeting Minutes Section - Show for ALL roles -->
    <div>
      <p class="text-xs fw-bold border-0 mb-3">Past Meeting Minutes</p>

      <div v-if="meetings.length">
        <ul
          class="list-group scrollable-meeting-list border-0 p-3"
          v-if="meetings.length > 0"
        >
          <li
            v-for="(m, index) in meetings"
            :key="m.id"
            class="list-group-item d-flex justify-content-between align-items-center mb-2 border shadow rounded-lg p-2"
            :class="{ 'mt-2': index > 0 }"
          >
            <div class="me-3">
              <strong class="d-block">{{ format_date(m.meeting_date) }}</strong>
              <small class="d-block mt-1">{{ m.comments || 'No comments' }}</small>
            </div>
            <a
              :href="m.minutes_file_url"
              target="_blank"
              class="btn btn-primary-dark btn-sm shadow-sm text-xxs ms-auto"
            >
              View PDF
            </a>
          </li>
        </ul>
      </div>

      <div v-else class="text-muted mt-3 text">No meeting minutes found.</div>
      </div>
    </div>
</div>